import React from 'react';
import VoucherPage from './VoucherPage';

const WebsitePage: React.FC = () => {
  return <VoucherPage category="website" />;
};

export default WebsitePage;
